import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import {
	actionGetProvinces,
	actionGetCities
} from "../../actions/ProvinceActions";
import {
	TextField,
	SelectField,
	DatePicker,
	Checkbox
} from "redux-form-material-ui";
import { Card, CardText, CardTitle } from "material-ui/Card";
import { connect } from "react-redux";
import _ from "lodash";
import {
	actionCreateEmpresa,
	actionUpdateEmpresa,
	asyncCheckCuit,
	asyncCheckMail
} from "../../actions/EmpresaActions";
import {
	required,
	validateEmail,
	password,
	confirmPassword,
	confirmEmail
} from "../../common/validaciones";
import { MenuItem, RaisedButton, FlatButton } from "material-ui";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { EMPRESAS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR, handleSubmitFail } from "../../common/Util";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import { MaskedTextField } from "vault-react-components";
import "./Empresas.css";
import { ROL_ADMIN } from "../../common/Constants";

let _handleSubmitFail;
class EmpresaForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_CREATE
				? this.returnStateNewEmpresa()
				: this.props.modeCRU === MODE_CRU_UPDATE
					? this.returnStateEditEmpresa()
					: this.returnStateShowEmpresa();
		this.state = state;
		this.state = { ...this.state, disableCity: true };
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		_handleSubmitFail = handleSubmitFail.bind(this);
	}

	componentWillMount() {
		if (!this.props.modeCRU) {
			this.props.history.push(EMPRESAS);
		} else {
			this.props.actionGetProvinces();
			if (this.props.modeCRU !== MODE_CRU_CREATE) {
				if (this.props.empresa.city)
					this.props.actionGetCities(this.props.empresa.city.province.id);
				this.initializeValues();
			}
		}
	}

	returnStateShowEmpresa() {
		const state = {
			disabledField: true
		};
		return state;
	}

	returnStateNewEmpresa() {
		let state = {};
		return state;
	}

	returnStateEditEmpresa() {
		let state = {
			cuit: this.props.empresa.cuit
		};
		return state;
	}

	initializeValues() {
		const empresa = this.props.empresa;
		this.props.initialize({
			...empresa,
			currentCuit: empresa.cuit,
			currentMail: empresa.user ? empresa.user.email : "",
			terms: true,
			entryDate: Util.isoDateToJavascriptDate(empresa.entryDate)
		});
	}

	InputMask = props => {
		const { input, meta, ...custom } = props;
		return (
			<MaskedTextField
				{...input}
				{...custom}
				touched={meta.touched}
				error={meta.error}
			/>
		);
	};

	formatDate(date) {
		return Util.formatDateToShowNotHour(date);
	}

	onSubmit(formValues) {
		const values = formValues;
		values.entryDate = Util.formatDateToISODate(values.entryDate);
		values.cuit = _.startsWith(values.cuit, "-", 2)
			? values.cuit.split("-").join("")
			: values.cuit;
		if (!formValues.terms) {
			Util.showNoty(ERROR, "Debe aceptar que Declara Bajo Juramento");
		} else {
			if (this.props.modeCRU === MODE_CRU_CREATE) {
				this.props.actionCreateEmpresa(values, this.returnOnSubmit);
			} else
				this.props.actionUpdateEmpresa(
					this.props.empresa._id,
					values,
					this.returnOnSubmit
				);
		}
	}

	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				if (this.props.rol !== ROL_ADMIN)
					Util.showNoty(
						SUCCESS,
						"Revise su correo electrónico y active su cuenta"
					);
				this.props.history.goBack();
			} else if (response === ERROR) {
				Util.showNoty(ERROR, "Error al crear empresa");
			}
		} else if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Empresa modificada exitosamente");
			this.props.history.push(EMPRESAS);
		} else if (response === ERROR) {
			Util.showNoty(ERROR, "Error al modificar empresa");
		}
	}

	ableToEdit = () => {
		//TODO
		// if (this.props.modeCRU === MODE_CRU_UPDATE)
		// 	return this.state.minDate < new Date() ? true : this.state.enableField;
		return this.state.disabledField;
	};

	getEstados() {
		const estados = [];
		estados.push(
			<MenuItem
				value="DATOS A CONFIRMAR"
				key={1}
				primaryText={"DATOS A CONFIRMAR"}
			/>
		);
		estados.push(<MenuItem value="ACTIVA" key={2} primaryText={"ACTIVA"} />);
		estados.push(<MenuItem value="BAJA" key={3} primaryText={"BAJA"} />);
		return estados;
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						style={{ paddingBottom: 10 }}
						title={"Empresa"}
						subtitle={
							"Complete todos los campos cuidadosamente antes de enviar la solicitud. Los datos consignados están sujetos a verificación por parte de UPSRA"
						}
					/>
					<CardText>
						<form>
							<div className="content-papercard">
								<VerticalListFields
									titleText="Datos de la Empresa"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<Field name="currentCuit" component="input" type="hidden" />
									<Field name="currentMail" component="input" type="hidden" />
									<Field
										name="name"
										component={TextField}
										floatingLabelText="Razón Social"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
									/>
									<div>
										<Field
											name="cuit"
											ref="cuit"
											component={this.InputMask}
											floatingLabelText="CUIT"
											validate={[required]}
											fullWidth
											mask={[
												/\d/,
												/\d/,
												"-",
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												/\d/,
												"-",
												/\d/
											]}
											disabled={this.ableToEdit()}
										/>
									</div>
									<Field
										name="address"
										component={TextField}
										floatingLabelText="Dirección"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
									/>
									<Field
										name="city.province.id"
										component={SelectField}
										floatingLabelText="Provincia"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
										onChange={(event, value) => {
											this.setState({ disableCity: false });
											this.props.actionGetCities(value);
										}}
									>
										{_.map(this.props.provinciasList, (provincia, i) => {
											return (
												<MenuItem
													key={i + 1}
													value={provincia.id}
													primaryText={provincia.name}
												/>
											);
										})}
									</Field>
									<Field
										name="city.id"
										component={SelectField}
										floatingLabelText="Localidad"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
									>
										{_.map(this.props.cityList, (city, i) => {
											return (
												<MenuItem
													key={i + 1}
													value={city.id}
													primaryText={city.name}
												/>
											);
										})}
									</Field>
									<Field
										name="postCode"
										component={TextField}
										floatingLabelText="Código Postal"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
									/>
									<Field
										name="phone"
										component={TextField}
										floatingLabelText="Teléfono"
										validate={[required]}
										fullWidth
										disabled={this.ableToEdit()}
									/>
									<Field
										name="email"
										component={TextField}
										floatingLabelText="Email"
										validate={[validateEmail, required]}
										fullWidth
										disabled={this.ableToEdit()}
									/>
									<Field
										name="entryDate"
										component={DatePicker}
										floatingLabelText="Fecha de Inicio de Actividad"
										hintText="dd/mm/aaaa"
										validate={[required]}
										fullWidth
										format={null}
										formatDate={this.formatDate}
										maxDate={new Date()}
										disabled={this.ableToEdit()}
									/>
									{this.props.rol === ROL_ADMIN ? (
										<Field
											name="state"
											component={SelectField}
											floatingLabelText="Estado"
											validate={[required]}
											fullWidth
											disabled={this.ableToEdit()}
										>
											{this.getEstados()}
										</Field>
									) : null}
								</VerticalListFields>
								<VerticalListFields
									titleText="Datos del Usuario"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<Field
										name="user.email"
										component={TextField}
										floatingLabelText="Email"
										validate={[validateEmail, required]}
										fullWidth
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									/>
									<Field
										name="reemail"
										component={TextField}
										floatingLabelText="Repetir Email"
										validate={
											this.props.modeCRU === MODE_CRU_CREATE
												? [confirmEmail, required]
												: null
										}
										fullWidth
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
										onPaste={event => event.preventDefault()}
									/>
									<Field
										name="user.password"
										component={TextField}
										type="password"
										floatingLabelText="Clave"
										validate={
											this.props.modeCRU === MODE_CRU_CREATE
												? [password, required]
												: null
										}
										fullWidth
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									/>
									<Field
										name="repassword"
										type="password"
										component={TextField}
										floatingLabelText="Repetir Clave"
										validate={
											this.props.modeCRU === MODE_CRU_CREATE
												? [confirmPassword, required]
												: null
										}
										fullWidth
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									/>
								</VerticalListFields>
								<div className="top20">
									<Field
										name="terms"
										label="Declaro bajo juramento, que los datos consignados en este formulario son correctos y que se ha confeccionado en carácter de declaración jurada sin omitir ni falsear dato alguno que deba contener, siendo fiel expresión de la verdad."
										component={Checkbox}
										disabled={this.props.modeCRU !== MODE_CRU_CREATE}
									/>
								</div>
							</div>
							<div className="top20 text-right">
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.goBack()}
									style={{ margin: 5 }}
								/>
								{this.props.modeCRU !== MODE_CRU_SHOW ? (
									<RaisedButton
										label="Aceptar"
										disabled={this.state.cantSubmit}
										primary
										style={{ margin: 5 }}
										onClick={handleSubmit(this.onSubmit.bind(this))}
									/>
								) : null}
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

const asyncValidate = (values, dispatch, props, currentFieldName) => {
	if (currentFieldName === "cuit") {
		let cuit = _.startsWith(values.cuit, "-", 2)
			? values.cuit
					.split("-")
					.join("")
					.split("_")
					.join("")
			: values.cuit;
		if (cuit !== values.currentCuit) {
			return asyncCheckCuit(cuit).then(response => {
				if (response) {
					// eslint-disable-next-line
					throw {
						cuit:
							"Esta empresa ya posee un usuario habilitado para presentar declaraciones juradas. Comuníquese con nosotros si desea actualizar su usuario al teléfono (11) 5263-7348 Int. 118 (Recaudaciones) de lunes a viernes de 9:00 a 17:00 horas."
					};
				}
			});
		} else {
			return new Promise(async (resolve, reject) => {
				resolve("");
			});
		}
	} else if (currentFieldName === "user.email") {
		if (values.user.email !== values.user.currentEmail) {
			return asyncCheckMail(values.user.email).then(response => {
				if (response) {
					// eslint-disable-next-line
					throw {
						user: {
							email: "Este mail pertenece a un usuario ya registrado."
						}
					};
				}
			});
		} else {
			return new Promise(async (resolve, reject) => {
				resolve("");
			});
		}
	} else {
		return new Promise(async (resolve, reject) => {
			resolve("");
		});
	}
};

function mapStateToProps(store) {
	return {
		empresa: store.empresa.empresa,
		provinciasList: store.locations.provinciasList,
		cityList: store.locations.ciudadesList,
		modeCRU: store.empresa.modeCRU,
		rol: store.app.rol
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetProvinces,
			actionCreateEmpresa,
			actionUpdateEmpresa,
			actionGetCities,
			asyncCheckCuit,
			asyncCheckMail
		},
		dispatch
	);
}

export default reduxForm({
	form: "EmpresaForm",
	asyncValidate,
	asyncBlurFields: ["cuit", "user.email"],
	onSubmitFail: errors => _handleSubmitFail(errors)
})(connect(mapStateToProps, mapDispatchToProps)(EmpresaForm));



// WEBPACK FOOTER //
// ./src/screens/Empresa/EmpresaForm.js